import { useRef } from 'react'

import { EVENT_NAME_CLICK } from '../constants/event'

import { useEventListener } from './useEventListener'

export function useEventOutside(handler, eventName = EVENT_NAME_CLICK) {
  const ref = useRef(null)

  function listener(event) {
    const element = ref?.current

    if (element && !element.contains(event.target)) {
      handler?.()
    }
  }

  useEventListener({ eventName, handler: listener })

  return ref
}
